import { ComboboxDivider } from '../ComboboxDivider';
import { ComboboxOption } from '../ComboboxOption';
import { ComboboxOptionMoreInfo } from '../ComboboxOptionMoreInfo';
import { SelectTextField as BaseSelectTextField } from './SelectTextField';

export {
    type SelectTextFieldProps,
    type SingleSelectTextFieldProps,
    type MultipleSelectTextFieldProps,
} from './SelectTextField';

/**
 * Select text field
 *
 * An accessible text field with a list box showing a list of options,
 * allowing the user to search and pick an item from this list.
 * It follows the combobox pattern.
 *
 * @family Combobox
 */
export const SelectTextField = Object.assign(BaseSelectTextField, {
    Option: ComboboxOption,
    OptionMoreInfo: ComboboxOptionMoreInfo,
    Divider: ComboboxDivider,
});
